// One user pill, one bell, one flag on the website and the forum (owner 2026-11-04: "unify the user pills between forum
// and website, add the notification bell and flag to the website as well, it needs to sync instantly").
//  - The pill menu: the same entries, labels and order as the website's (web/src/views/partials/header.ts userItems):
//    Account, Security, Coins, Forum profile, Forum settings, Admin (website, admins), Forum administration (admins),
//    Log out. index.js adds the website items; here Flarum's own Settings / Administration / Log Out get the website's
//    labels.
//  - Live counts: the website is the hub (the forum is PHP behind Apache: no long-lived connections there). The forum's
//    page opens the website's live stream (GET <aethernalLiveUrl>/api/notifications/stream, the website session cookie,
//    CORS for this forum's origin) and copies the counts into Flarum's session user, so the forum's bell and flag
//    badges change at once when something happens on either site. Without EventSource, or when the stream fails, it
//    asks /api/notifications/counts every 30 s while the page is visible. A visitor without a website session (401)
//    gets no stream and no polling: the forum then updates its badges on page loads, as before.
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
const t = key => app.translator.trans(`aethernal-forum.forum.${key}`);
export const POLL_MS = 30000;

/** Puts the website's counts ({linked, unread, new, flags: {new, total} | null, messages}) into Flarum's state; returns whether
 *  anything changed. A drop in unread (read elsewhere) empties the cached list so the next open reloads it. */
export function applyCounts(c, user = app.session.user) {
  if (!c || c.linked !== true || !user) return false;
  const num = v => Number.isInteger(v) && v >= 0 ? v : 0;
  const read = () => [user.unreadNotificationCount(), user.newNotificationCount(), user.attribute('newFlagCount'), app.forum.attribute('flagCount'), user.attribute('unreadDialogCount')];
  const before = read();
  const attrs = {
    unreadNotificationCount: num(c.unread),
    newNotificationCount: num(c.new)
  };
  if (c.flags) attrs.newFlagCount = num(c.flags.new);
  if (Number.isInteger(c.messages)) attrs.unreadDialogCount = num(c.messages);
  user.pushAttributes(attrs);
  if (c.flags) app.forum.pushAttributes({
    flagCount: num(c.flags.total)
  });
  const after = read();
  const changed = before.some((v, i) => v !== after[i]);
  if (changed && app.notifications && after[0] !== before[0] && typeof app.notifications.clear === 'function') app.notifications.clear();
  if (changed && c.flags && app.flags && after[3] !== before[3] && typeof app.flags.clear === 'function') app.flags.clear();
  // private messages (flarum/messages): the menu's list reloads when the unread conversations change
  if (changed && after[4] !== before[4] && app.dropdownDialogs && typeof app.dropdownDialogs.clear === 'function') app.dropdownDialogs.clear();
  return changed;
}
function startLive() {
  const base = app.forum.attribute('aethernalLiveUrl');
  if (!app.session.user || !base || window.__aetLive) return;
  window.__aetLive = true;
  const got = data => {
    try {
      if (applyCounts(JSON.parse(data))) m.redraw();
    } catch (e) {
      // ignore a malformed message
    }
  };
  let timer = null;
  const poll = () => {
    if (timer) return;
    const tick = () => {
      if (document.visibilityState === 'hidden') return;
      fetch(`${base}/api/notifications/counts`, {
        credentials: 'include',
        headers: {
          Accept: 'application/json'
        }
      })
      // 401 = no website session, 404 = a website without the bell (deploy order): stop asking
      .then(r => r.status === 401 || r.status === 404 ? (clearInterval(timer), null) : r.ok ? r.text() : null).then(txt => txt && got(txt)).catch(() => {});
    };
    timer = setInterval(tick, POLL_MS);
    tick();
  };
  if (typeof window.EventSource !== 'function') return poll();
  const es = new EventSource(`${base}/api/notifications/stream`, {
    withCredentials: true
  });
  let opened = false;
  let failures = 0;
  es.addEventListener('open', () => {
    opened = true;
    failures = 0;
  });
  es.addEventListener('counts', e => got(e.data));
  es.addEventListener('error', () => {
    // CLOSED = the website refused (no session, too many streams): poll instead; else EventSource reconnects by itself
    failures += 1;
    if (es.readyState === 2 || !opened && failures >= 3) {
      es.close();
      poll();
    }
  });
}
app.initializers.add('aethernal-forum-unipill', () => {
  extend('flarum/forum/components/SessionDropdown', 'items', function (items) {
    if (items.has('settings')) {
      items.setContent('settings', m(LinkButton, {
        icon: "fas fa-cog",
        href: app.route('settings')
      }, t('nav_forum_settings')));
    }
    if (items.has('logOut')) {
      items.setContent('logOut', m(Button, {
        icon: "fas fa-sign-out-alt",
        onclick: app.session.logout.bind(app.session)
      }, t('nav_logout')));
    }
    if (items.has('administration')) {
      items.setContent('administration', m(LinkButton, {
        icon: "fas fa-wrench",
        href: app.forum.attribute('adminUrl'),
        target: "_blank"
      }, t('nav_forum_admin')));
    }
  });

  // after boot (the session user is known by then)
  setTimeout(startLive, 0);
});